'use client'

import { memo, type ReactNode } from 'react'
import { EvervaultCard, type EvervaultCardProps } from '@/components/ui/evervault-card'
import { cn } from '@/lib/utils'

type EvervaultSize = NonNullable<EvervaultCardProps['size']>

/**
 * Full-bleed embed: same as /nin NinPrivacyVault: one EvervaultCard, copy inside,
 * outer shell is overflow-hidden with zero padding.
 */
export const NinxlEvervaultShell = memo(function NinxlEvervaultShell({
  children,
  className,
  contentClassName,
  size = 'lg',
  roundedClassName = 'rounded-none',
}: {
  children: ReactNode
  className?: string
  contentClassName?: string
  size?: EvervaultSize
  roundedClassName?: string
}) {
  return (
    <div className={cn('relative w-full overflow-hidden', className)}>
      <EvervaultCard
        hideLabel
        size={size}
        className="w-full"
        roundedClassName={roundedClassName}
        contentClassName={contentClassName}
      >
        {children}
      </EvervaultCard>
    </div>
  )
})
